import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

import { overviewFontBuilderCss } from "../OverviewDataResults/OverviewDataResults.style";

const { mediaQuery: breakpoint } = mediaQueryStyles;
const {
  breakpoints: { BreakpointNames },
} = constants;

const { ui } = constants.colors;
const darkGrey700 = ui.neutral[700];

export const overviewInfoContainer: CSSObject = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "start",
  margin: "32px 0 32px 0",
};

export const overviewTitleContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
};

export const overviewExplanationTextCss: CSSObject = {
  width: "100%",
  color: darkGrey700,
  ...overviewFontBuilderCss({
    textOverflow: "ellipsis",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "150%",
  }),

  [breakpoint.downTo(BreakpointNames.md)]: {
    width: "85%",
  },
};

export const overviewTitleCss: CSSObject = {
  color: darkGrey700,
  margin: "0 0 8px 0",
  ...overviewFontBuilderCss({
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "133%",
  }),
};
